// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__1wmVN","modalForm":"UpgradeEpcsModal_modalForm__dbarC","modalFooter":"UpgradeEpcsModal_modalFooter__3HWOv"};